import React from "react";
import { useHistory } from "react-router-dom";
import { ArrowLeft, Users } from "lucide-react";
import PageHeader from "../../../components/PageHeader";
import CompanyWizard from "../../../components/CompanyWizard";
import { createAdminCompany } from "../../../services/adminCompanies";

const CompaniesNew = () => {
  const history = useHistory();

  const handleSubmit = async (form) => {
    const payload = {
      name: form.name,
      document: form.document || undefined,
      email: form.email || undefined,
      phone: form.phone || undefined,
      timezone: form.timezone || undefined,
      internalNotes: form.internalNotes || undefined,
      postalCode: form.postalCode || undefined,
      street: form.street || undefined,
      number: form.number || undefined,
      complement: form.complement || undefined,
      district: form.district || undefined,
      city: form.city || undefined,
      state: form.state || undefined,
      personType: form.personType || undefined,
      legalName: form.legalName || undefined,
      tradeName: form.tradeName || undefined,
      municipalRegistration: form.municipalRegistration || undefined,
      stateRegistration: form.stateRegistration || undefined,
      taxRegime: form.taxRegime || undefined,
      cnae: form.cnae || undefined,
      fiscalEmail: form.fiscalEmail || undefined
    };

    const result = await createAdminCompany(payload);
    history.push(`/companies/${result.company.id}`);
  };

  return (
    <div className="space-y-4">
      <PageHeader
        breadcrumb="Clientes & Acessos"
        title="Nova Empresa"
        subtitle="Cadastro de uma nova empresa na plataforma"
        action={
          <button onClick={() => history.push("/companies")}
            className="flex items-center gap-2 px-4 py-2 bg-gray-100 dark:bg-white/5 hover:bg-gray-200 dark:hover:bg-white/10 text-xs font-bold text-gray-700 dark:text-gray-300 rounded-xl">
            <ArrowLeft size={14} /> Voltar
          </button>
        }
      />

      <div className="neumorphic-card rounded-2xl p-4 border border-blue-500/20 bg-blue-500/5">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 rounded-lg bg-blue-500/10 border border-blue-500/20 text-blue-500 dark:text-blue-400 flex items-center justify-center flex-shrink-0">
            <Users size={16} />
          </div>
          <p className="text-xs text-gray-500 dark:text-gray-400">
            O usuario da empresa sera criado posteriormente no modulo <strong>Usuarios</strong>.
          </p>
        </div>
      </div>

      <CompanyWizard
        onSubmit={handleSubmit}
        submitLabel="Criar Empresa"
        backPath="/companies"
      />
    </div>
  );
};

export default CompaniesNew;
